export const onPhoneClick = (number = '') => {
  if (number.startsWith('+')) {
    window.open(`tel:${number}`)
  } else {
    window.open(`tel:+${number}`)
  }
}
